<template>
  <div id="">
    <div class="">
      <div class="card-body">
        <div class="row d-flex justify-content-space-around align-items-end">
          <h3 class="col-md-9 p-0 col-12 text-dark">
            {{ $t('Borracharia') }} - {{ $t('Placas') }}
          </h3>
          <div class="col-md-3 p-0 col-12">
            <label>{{ $t('Placas') }}</label>
            <v-select :options="veiculos" @input="filterPlaca($event)" placeholder="Placa">
            </v-select>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  data() {
    return {
      isSidebarOpen: false,
      showFiltros: false,
    }
  },

  components: {
  },

  computed: {
    veiculos() {
      const itemsFiltros = this.$store.getters['borracharia/getPlacas']
      // console.log(itemsFiltros)

      if (!itemsFiltros) {
        this.$store.dispatch('borracharia/fetchFromPlacas')
        return []
      }

      return itemsFiltros.map(item => {
        return {
          ...item,
          label: item.nr_placa
        }
      })
    },


    filtros() {
      return this.$store.getters['os/filters']
    },

    internalFilters() {
      return { ...this.filtros }
    },
  },
  methods: {
    filterPlaca(event) {
      console.log(event)

      if(event == null) {
        this.$store.commit('borracharia/clearFilterPlaca', '')
      } else {
        this.$store.commit('borracharia/setFilterPlaca', event.nr_placa)
      }

    },

    applyFilters() {
      let filters = { ...this.internalFilters }

      this.$store.commit('os/setFilters', { filters: filters })

      document.getElementById('btnFiltro').click()
    },

    fetchItemsFromApi() {
      this.$store.dispatch('os/fetchFromApi')
    },
    resetFilters() {
      const filters = {
        placa: '',
        tipo: '',
        de: '',
        ate: '',
        codigo: '',
        segmento: ''
      }
      document.getElementById('btnFiltro').click()
      this.$store.commit('os/setFilters', { filters: filters })
    },
    esconderFiltros() {
      this.showFiltros = !this.showFiltros
      this.$scrollTo('#osList')
    }
  },

}
</script>